import Button, { type ButtonProps } from "@mui/material/Button";

import { clsx } from "./clsx";
import styles from "./TextButton.module.css";
import { disableInput } from "./Utility";

export const TextButton: React.FC<ButtonProps> = ({ className, ...props }) => {
  return (
    <Button
      className={clsx(styles.textButton, className)}
      onMouseDown={disableInput}
      onTouchStart={disableInput}
      variant={"contained"}
      {...props}
    >
      {props.children}
    </Button>
  );
};
